import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Plate } from "@/components/Plate";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function AccessList() {
  const [items, setItems] = useState([]);
  const [plate, setPlate] = useState("");
  const [listType, setListType] = useState("whitelist");
  const [note, setNote] = useState("");

  const load = async () => {
    const { data } = await api.get("/access-list");
    setItems(data);
  };

  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!plate) return;
    try {
      await api.post("/access-list", { plate, list_type: listType, note });
      toast.success("Eklendi");
      setPlate(""); setNote("");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Eklenemedi"); }
  };

  const del = async (id) => {
    try { await api.delete(`/access-list/${id}`); toast.success("Silindi"); load(); }
    catch (e) { toast.error("Silinemedi"); }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Erişim</div>
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">Beyaz / Kara Liste</h1>
      </div>

      <Card className="rounded-sm border-border">
        <CardContent className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
            <div>
              <Label>Plaka</Label>
              <Input data-testid="access-plate-input" placeholder="34ABC123" value={plate} onChange={(e) => setPlate(e.target.value.toUpperCase())} className="rounded-sm font-plate uppercase" />
            </div>
            <div>
              <Label>Liste</Label>
              <Select value={listType} onValueChange={setListType}>
                <SelectTrigger className="rounded-sm" data-testid="access-list-type"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="whitelist">Beyaz Liste (Muaf)</SelectItem>
                  <SelectItem value="blacklist">Kara Liste (Yasak)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="md:col-span-1">
              <Label>Not</Label>
              <Input value={note} onChange={(e) => setNote(e.target.value)} className="rounded-sm" placeholder="opsiyonel" />
            </div>
            <Button data-testid="access-add-btn" onClick={add} className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-semibold">
              Ekle
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-sm border-border">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Plaka</TableHead>
                <TableHead>Liste</TableHead>
                <TableHead>Not</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.length === 0 && <TableRow><TableCell colSpan={4} className="text-center py-8 text-muted-foreground">Kayıt yok</TableCell></TableRow>}
              {items.map((it) => (
                <TableRow key={it.id}>
                  <TableCell><Plate>{it.plate}</Plate></TableCell>
                  <TableCell>
                    <Badge variant={it.list_type === "blacklist" ? "destructive" : "outline"} className="rounded-sm uppercase text-[10px] tracking-widest">
                      {it.list_type === "blacklist" ? "Kara" : "Beyaz"}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-sm text-muted-foreground">{it.note || "—"}</TableCell>
                  <TableCell>
                    <Button data-testid={`access-del-${it.plate}`} variant="ghost" size="sm" onClick={() => del(it.id)}><Trash size={16} /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
